import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp, FaArrowRight } from 'react-icons/fa';
import ContactCTA from '../components/ContactCTA';
import '../styles/EmployerFAQs.css';

const employerFAQs = [
  {
    question: 'What types of candidates do you provide?',
    answer: 'We provide candidates across various skill levels and industries including healthcare professionals, engineers, IT specialists, administrative staff, manufacturing workers, and executive-level positions. All candidates are pre-screened and verified to match your specific requirements.'
  },
  {
    question: 'How do you screen and verify candidates?',
    answer: 'Our comprehensive screening process includes background checks, employment history verification, skills assessment, reference checks, and in-depth interviews. We ensure all candidates meet legal work authorization requirements and possess the qualifications they claim.'
  },
  {
    question: 'Do you offer replacement guarantees?',
    answer: 'Yes, we offer a replacement guarantee period for all permanent placements. If a candidate does not work out within the guarantee period, we will find a replacement at no additional cost to you.'
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We specialize in healthcare, technology, finance, manufacturing, engineering, hospitality, and administrative sectors. Our industry-specific recruiters understand the unique requirements and challenges of each field.'
  },
  {
    question: 'How do you handle international candidates?',
    answer: 'We have extensive experience with international placements and can assist with visa processing, work permits, and relocation support. Our immigration services team ensures compliance with all regulations and smooth transitions for international hires.'
  },
  {
    question: 'Can you handle bulk hiring requirements?',
    answer: 'Absolutely! We have the capacity and resources to handle high-volume recruitment projects. Our scalable solutions ensure consistent quality whether you need one hire or hundreds.'
  }
];

const FAQItem = ({ faq, index, isOpen, onToggle }) => {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={onToggle}>
        <span className="faq-number">Q{index + 1}</span>
        <span className="faq-text">{faq.question}</span>
        {isOpen ? <FaChevronUp className="faq-icon" /> : <FaChevronDown className="faq-icon" />}
      </button>
      <div className="faq-answer">
        <p>{faq.answer}</p>
      </div>
    </div>
  );
};

const EmployerFAQs = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (section, index) => {
    const key = `${section}-${index}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isOpen = (section, index) => {
    return openItems[`${section}-${index}`] || false;
  };

  return (
    <div className="employer-faqs-page">
      <section className="page-hero">
        <div className="container">
          <h1>Employer FAQs</h1>
          <p>Your Guide to Partnering with JOY WORLDWIDE CONSULTANCY SERVICES</p>
        </div>
      </section>

      <section className="faqs-intro">
        <div className="container">
          <div className="faqs-intro-grid">
            <div className="faqs-intro-content">
              <p className="intro-text">
                Find answers to commonly asked questions about our candidate sourcing, placement process,
                and partnership benefits for employers.
              </p>
            </div>
            {/* <div className="faqs-intro-image">
              <img
                src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                alt="Business consultation and support"
                className="faqs-help-img"
              />
            </div> */}
          </div>
        </div>
      </section>

      <section className="faqs-section">
        <div className="container">
          <div className="faq-category">
            <div className="faq-list">
              {employerFAQs.map((faq, index) => (
                <FAQItem
                  key={index}
                  faq={faq}
                  index={index}
                  isOpen={isOpen('employer', index)}
                  onToggle={() => toggleItem('employer', index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="faqs-cta">
        <div className="container">
          <h2>Ready to Start Hiring?</h2>
          <p>Contact us today to discuss your staffing needs</p>
          <Link to="/for-employers" className="btn btn-primary">
            Get Started <FaArrowRight className="btn-icon" />
          </Link>
        </div>
      </section>

      <ContactCTA />
    </div>
  );
};

export default EmployerFAQs;
